import { UITabbedPanel, UISpan } from '@/components/assets/js/libs/ui.js';

import { SidebarScene } from './Sidebar.Scene.js';
import { SidebarProperties } from './Sidebar.Properties.js';
import { SidebarProject } from './Sidebar.Project.js';
import { SidebarSettings } from './Sidebar.Settings.js';
import { SidebarCompanyInfo } from './Sidebar.Companyinfo.js';
import { SidebarReport } from './Sidebar.Report.js';

function Sidebar( editor ) {

	const strings = editor.strings;

	const container = new UITabbedPanel();
	container.setId( 'sidebar' );
	if (window.Viewmode === "WebManual")
	{
		container.setTop('60px'); 
	}

	// eslint-disable-next-line no-unused-vars
	const scene = new UISpan().add(
		new SidebarScene( editor ),
		new SidebarProperties( editor )
	);
	// eslint-disable-next-line no-unused-vars
	const project = new SidebarProject( editor );
	const settings = new SidebarSettings( editor );
	const companyInfo = new SidebarCompanyInfo( editor );
	const report = new SidebarReport( editor );
	container.addTab( 'companyInfo', strings.getKey( 'sidebar/companyinfo' ), companyInfo );
	container.addTab( 'report', strings.getKey( 'sidebar/report' ), report );
	//container.addTab( 'scene', strings.getKey( 'sidebar/scene' ), scene );
	//container.addTab( 'project', strings.getKey( 'sidebar/project' ), project );
	container.addTab('settings', strings.getKey('sidebar/settings'), settings);
	container.select( 'report' );

	if(window.Viewmode === 'Monitoring')
	{
		container.dom.style.display = 'none'; 
		container.dom.style.visibility = 'hidden'; 
	}


	return container;

}

export { Sidebar };
